import { ConfirmationDialog } from '../Dialogs/ConfirmationDialog';
import { Node } from '../../domain/domain';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../reducers';
import { ComponentManagementActionType } from '../../reducers/comp.actions';

type Props = {
    onReject: (node: Node) => void
}

const RejectComponentDialog: React.FC<Props> = ({onReject}) => {

    const open = useSelector((app: ApplicationState) => app.comp.rejectComponentDialogOpen);
    const editorNode = useSelector((app: ApplicationState) => app.comp.editorNode);
    const dispatch = useDispatch();

    if (!editorNode) {
        return <></>
    }

    return (
        <ConfirmationDialog
            open={open}
            title="Reject Component"
            contentText="Are you sure you want to reject this component?"
            handleNo={() => {
                dispatch({ type: ComponentManagementActionType.REJECT_COMPONENT_DIALOG_OPEN, open: false });
            }}
            handleYes={() => {
                onReject(editorNode);
                dispatch({ type: ComponentManagementActionType.REJECT_COMPONENT_DIALOG_OPEN, open: false });
            }}
        />
    )
}

export default RejectComponentDialog;